// removed by extract-text-webpack-plugin
module.exports = {"container":"_3eEidfDwqpfKhRcmNfQSUa","label":"_31OTP5x28v507paz3I_Wxb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Menu/Checkbox/styles.css
// module id = 2722
// module chunks = 0